import * as types from './meetings.types';
import * as constants from './meetings.constants';

export const initialMeetingPage = (): types.IInitialMeetingPage => ({
  type: constants.INITIAL_MEETING_PAGE,
});
